export type PublicOnboardingEvent =
  | "trial_cta_selected"
  | "authentication_route_opened"
  | "google_oauth_initiated"
  | "oauth_callback_completed"
  | "official_university_email_requested"
  | "verification_email_accepted"
  | "verification_link_completed"
  | "dashboard_reached";

type SafeProps = Record<string, string | number | boolean>;

/** Retired optional analytics only; necessary operational monitoring is separate. */
export function trackOnboardingEventOnce(_event: PublicOnboardingEvent, _props: SafeProps = {}): void {}
